import { nbspToSpacePlugin } from './plugin'

export const initNbspToSpacePlugin = () => {
  if (CKEDITOR.plugins.get('nbsptospace')) {
    return
  }

  CKEDITOR.plugins.add('nbsptospace', nbspToSpacePlugin)
}
